import React, { useState } from "react";
import EN from "../../locales/en";
import Button from "../Button";
import SwitchNowButton from "../SwitchNowButton";
import QuoteTariffEstimatedCostsBox from "./Partials/QuoteTariffEstimatedCostsBox";
import QuoteTariffInfoBox from "./Partials/QuoteTariffInfoBox";
import SupplierLogo from "./Partials/SupplierLogo";
import SupplierTariffDetails from "./Partials/SupplierTariffDetails";
import QuoteDetailsModal from "./QuoteDetailsModal";

const TariffPreview = ({ tariff, showButtons = true }) => {
  const [detailsModalOpen, setDetailsModalOpen] = useState(false);

  return (
    <>
      <div className="overflow-hidden border-2 border-[#afb6b9] rounded-[4px] p-5">
        {tariff?.supplierImageUrl && (
          <SupplierLogo
            src={tariff?.supplierImageUrl}
            alt={tariff?.supplierName}
          />
        )}

        <SupplierTariffDetails
          supplierName={tariff?.supplierName}
          tariffName={tariff?.tariffName}
        />

        <QuoteTariffEstimatedCostsBox quote={tariff} />

        <QuoteTariffInfoBox quote={tariff} />

        {showButtons && (
          <div className="mt-6 flex flex-col space-y-4">
            {tariff?.isSwitchable ? (
              <SwitchNowButton quote={tariff} />
            ) : (
              <p className="text-center py-1">{EN.quotes.contact_supplier}</p>
            )}
            <Button
              onClick={() => setDetailsModalOpen(true)}
              variant="secondary"
            >
              {EN.quotes.view_details_text}
            </Button>
          </div>
        )}
      </div>

      <QuoteDetailsModal
        open={detailsModalOpen}
        setOpen={setDetailsModalOpen}
        quote={tariff}
      />
    </>
  );
};

export default TariffPreview;
